<div class="default-setup">
	<div class="">
		<div class="col col-sm-7 col-sm-offset-5 pull-right no-padding">
			<h4 class="normal fs22">
				You’ve chosen the <strong>Default Setup</strong>. This includes:
			</h4>
			<ul class="arrow-list">
				<li>The Modern Visual Theme</li>
				<li>Only the General Session List</li>
				<li>A basic left oriented Filter, showing Track, Session Type, Dates, and Tags</li>
				<li>Data for the General Session List to include All Published Sessions</li>
			</ul>
		</div>
	</div>
</div>